{
  "name": "logistica",
  "version": "1.9.9",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --ssl --host logistica-dev.unimedinconfidentes.coop.br",
    "build": "ng build",
    "build:development": "ng build --configuration=development",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "ng test --no-watch --browsers=ChromeHeadlessNoSandbox",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:ci": "playwright test --reporter=github",
    "pretty-quick": "pretty-quick --staged",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "overrides": {
    "vite": "7.3.2",
    "ws": "8.20.1"
  },
  "dependencies": {
    "@angular/animations": "^21.2.14",
    "@angular/cdk": "^21.2.12",
    "@angular/common": "^21.2.14",
    "@angular/compiler": "^21.2.14",
    "@angular/core": "^21.2.14",
    "@angular/forms": "^21.2.14",
    "@angular/platform-browser": "^21.2.14",
    "@angular/router": "^21.2.14",
    "@ngneat/overview": "^7.0.0",
    "@ngxpert/hot-toast": "^6.1.0",
    "@popperjs/core": "^2.11.8",
    "apexcharts": "^5.3.6",
    "bootstrap": "^5.3.8",
    "bootstrap-icons": "^1.13.1",
    "flatpickr": "^4.6.13",
    "ng-apexcharts": "^2.0.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.4.0",
    "@angular/build": "^21.2.12",
    "@angular/cli": "^21.2.12",
    "@angular/compiler-cli": "^21.2.14",
    "@angular/localize": "^21.2.14",
    "@eslint/js": "^9.39.4",
    "@playwright/test": "^1.60.0",
    "@types/flatpickr": "^3.1.4",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^24.12.4",
    "angular-eslint": "^21.4.0",
    "eslint": "^9.39.4",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.58.0"
  }
}